"use strict";
/* This is a generated file, do not edit */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delivery = void 0;
var DispenserRequestItem_1 = require("../../rmf_dispenser_msgs/msg/DispenserRequestItem");
var Behavior_1 = require("../../rmf_task_msgs/msg/Behavior");
var Delivery = /** @class */ (function () {
    function Delivery(fields) {
        if (fields === void 0) { fields = {}; }
        this.task_id = fields.task_id || '';
        this.items = fields.items || [];
        this.pickup_place_name = fields.pickup_place_name || '';
        this.pickup_dispenser = fields.pickup_dispenser || '';
        this.pickup_behavior = fields.pickup_behavior || new Behavior_1.Behavior();
        this.dropoff_place_name = fields.dropoff_place_name || '';
        this.dropoff_ingestor = fields.dropoff_ingestor || '';
        this.dropoff_behavior = fields.dropoff_behavior || new Behavior_1.Behavior();
    }
    Delivery.validate = function (obj) {
        var e_1, _a;
        if (typeof obj['task_id'] !== 'string') {
            throw new Error('expected "task_id" to be "string"');
        }
        if (!Array.isArray(obj['items'])) {
            throw new Error('expected "items" to be an array');
        }
        try {
            for (var _b = __values(obj['items'].entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), i = _d[0], v = _d[1];
                try {
                    DispenserRequestItem_1.DispenserRequestItem.validate(v);
                }
                catch (e) {
                    throw new Error("in index ".concat(i, " of \"items\":\n  ") + e.message);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (typeof obj['pickup_place_name'] !== 'string') {
            throw new Error('expected "pickup_place_name" to be "string"');
        }
        if (typeof obj['pickup_dispenser'] !== 'string') {
            throw new Error('expected "pickup_dispenser" to be "string"');
        }
        try {
            Behavior_1.Behavior.validate(obj['pickup_behavior']);
        }
        catch (e) {
            throw new Error('in "pickup_behavior":\n  ' + e.message);
        }
        if (typeof obj['dropoff_place_name'] !== 'string') {
            throw new Error('expected "dropoff_place_name" to be "string"');
        }
        if (typeof obj['dropoff_ingestor'] !== 'string') {
            throw new Error('expected "dropoff_ingestor" to be "string"');
        }
        try {
            Behavior_1.Behavior.validate(obj['dropoff_behavior']);
        }
        catch (e) {
            throw new Error('in "dropoff_behavior":\n  ' + e.message);
        }
    };
    Delivery.FullTypeName = 'rmf_task_msgs/msg/Delivery';
    return Delivery;
}());
exports.Delivery = Delivery;
/*
# task_id is intended to be a pseudo-random string generated
# by the caller which can be used to identify this task as it
# moves between the queues to completion (or failure).
string task_id

rmf_dispenser_msgs/DispenserRequestItem[] items

string pickup_place_name
string pickup_dispenser
Behavior pickup_behavior

string dropoff_place_name
string dropoff_ingestor
Behavior dropoff_behavior

*/
